var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"saveModal",attrs:{"id":"save-modal","uk-modal":""}},[_c('SaveWarning',{staticClass:"uk-modal-dialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }